/**
 * TokenPushCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {TokenPush} from '@/model/resource/TokenPush'

/* TODO: review generated class */
@HttpExclude()
export class TokenPushCollection extends PageCollection<TokenPush> {
  constructor() {
    super(TokenPush)
  }

  queryAsPage() {
    return this.listTokenPush()
  }

  async listTokenPush() {
    return await Request.get(`/admin/token-push`, {params: this.params})
      .name('listTokenPush')
      .as(this)
      .getResponse()
  }

  async listCsvTokenPush() {
    return await Request.get(`/admin/token-push/csv`, {params: this.params})
      .name('listCsvTokenPush')
      .as(this)
      .getResponse()
  }
}
